import React, { useState } from 'react';
import { FiPlus, FiUsers } from 'react-icons/fi';
import HRMSidebar from '../components/HRMSidebar';
import GenericAddModal from '../components/GenericAddModal';
import useLocalState from '../hooks/useLocalState';
import { sortData } from '../utils/tableUtils';

const initialData = [
  { ref: 'EMP-001', name: 'Wan Yee Lui', title: 'Administrator', dept: 'Management', email: 'wanyee@wylimited.com', phone: '-', status: 'Active' }
];

export default function Employees() {
  const [data, setData] = useLocalState('employees_data', initialData);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: 'ref', direction: 'asc' });

  const handleAdd = (newData) => setData([{ ...newData, status: 'Active' }, ...data]);
  const handleSort = (key) => setSortConfig({ key, direction: sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc' });
  const sortedData = sortData(data, sortConfig);

  return (
    <div className="flex h-full font-sans overflow-hidden bg-white">
      <HRMSidebar />
      <div className="flex-1 flex flex-col bg-[#a6e4e7] p-2">
        <div className="flex justify-between items-center mb-3 px-1">
          <div className="flex items-center space-x-2">
            <FiUsers className="text-xl text-teal-800" />
            <span className="font-medium text-[15px] text-teal-700">Employees ({data.length})</span>
          </div>
          <button onClick={() => setIsModalOpen(true)} className="bg-[#0000a0] text-white p-1.5 rounded hover:bg-blue-900"><FiPlus /></button>
        </div>
        <div className="flex-1 overflow-x-auto bg-white border border-black">
          <table className="min-w-full border-collapse text-[12px]">
            <thead>
              <tr className="bg-[#a6e4e7] text-teal-900">
                <th onClick={() => handleSort('ref')} className="p-2 border border-black text-left cursor-pointer">Ref.</th>
                <th onClick={() => handleSort('name')} className="p-2 border border-black text-left cursor-pointer">Name</th>
                <th onClick={() => handleSort('title')} className="p-2 border border-black text-left cursor-pointer">Job Title</th>
                <th className="p-2 border border-black text-left">Department</th>
                <th className="p-2 border border-black text-left">Email</th>
                <th className="p-2 border border-black text-center">Status</th>
              </tr>
            </thead>
            <tbody>
              {sortedData.map((row, idx) => (
                <tr key={idx} className="hover:bg-blue-50">
                  <td className="p-2 border border-black font-bold">{row.ref}</td>
                  <td className="p-2 border border-black">{row.name}</td>
                  <td className="p-2 border border-black">{row.title}</td>
                  <td className="p-2 border border-black">{row.dept}</td>
                  <td className="p-2 border border-black">{row.email}</td>
                  <td className="p-2 border border-black text-center"><span className="bg-green-100 px-2 py-0.5 rounded">{row.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <GenericAddModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onAdd={handleAdd} title="Add Employee" fields={[
          { name: 'ref', label: 'Reference' }, { name: 'name', label: 'Full Name' }, { name: 'title', label: 'Job Title' },
          { name: 'dept', label: 'Department' }, { name: 'email', label: 'Email' }
        ]} />
      </div>
    </div>
  );
}